module.exports = __webpack_public_path__ + "img/subscription-active.f1c193a0.svg";